export const ASK_AI_MAX_PROMPT_LENGTH = 600;
export const ASK_AI_MIN_PROMPT_LENGTH = 15;
export const ASK_AI_LOADING_DURATION_MS = 12000;
export const ASK_AI_SLIDE_IN_DURATION_MS = 175;
export const ASK_AI_SLIDE_OUT_DURATION_MS = 150;
export const PLAN_APPROVAL_MESSAGE = 'Proceed with the plan';

export const AI_NODES_PACKAGE_NAME = '@n8n/n8n-nodes-langchain';

export const AI_ASSISTANT_MAX_CONTENT_LENGTH = 100; // in kilobytes
